// 編集コントロール（form ビュー / QuickEdit）。列型に応じた入力。
// Slice 1 は表示（値の反映）まで。onInput は Slice 2 の書き戻しで接続する。
import { label, keyOf } from "./model.mjs";
import type { Column, Locale } from "../types";

type Props = {
  col?: Column;
  columnId?: string;
  value: unknown;
  locale: Locale;
  compact?: boolean; // QuickEdit のセル用
  onInput?: (key: string, value: unknown) => void;
};

export function EditControl({ col, columnId, value, locale, compact, onInput }: Props) {
  const key = keyOf(col, columnId);
  const cls = compact ? "qe-input" : "rt-input";
  const v = value ?? "";
  const emit = (val: unknown) => onInput?.(key, val);

  let control;
  switch (col?.type) {
    case "enum":
      control = (
        <select class={cls} data-key={key} value={String(v)} onChange={(e) => emit((e.target as HTMLSelectElement).value)}>
          {(col.options ?? []).map((o) => (
            <option value={o.value}>{label(o.label, locale) || o.value}</option>
          ))}
        </select>
      );
      break;
    case "longtext":
      control = (
        <textarea class={cls} data-key={key} rows={2} value={String(v)} onInput={(e) => emit((e.target as HTMLTextAreaElement).value)} />
      );
      break;
    case "number":
    case "decimal":
      control = (
        <input type="number" class={cls} data-key={key} value={String(v)} onInput={(e) => emit((e.target as HTMLInputElement).value)} />
      );
      break;
    case "boolean":
      control = (
        <input type="checkbox" class={cls} data-key={key} checked={!!value} onChange={(e) => emit((e.target as HTMLInputElement).checked)} />
      );
      break;
    case "date":
      control = (
        <input type="date" class={cls} data-key={key} value={String(v)} onInput={(e) => emit((e.target as HTMLInputElement).value)} />
      );
      break;
    default:
      control = (
        <input type="text" class={cls} data-key={key} value={String(v)} onInput={(e) => emit((e.target as HTMLInputElement).value)} />
      );
  }

  if (compact) return control;
  return (
    <>
      <label class="rt-lbl">{label(col?.name, locale) || columnId || ""}</label>
      {control}
    </>
  );
}
